import React, { createContext } from 'react';
import moment from 'moment';
export const AvailabilityEditorContext = createContext(undefined);
export const AvailabilityEditorContextProvider = ({ children, data = new Array(7).fill(null).map(() => []), save, onFrom, onTo, PickerWrapper }) => {
    const add = (day) => {
        const current = data[day];
        const last = current[current.length - 1];
        if (!last) {
            toggle(day);
            return;
        }
        const now = moment().format('MM-DD-YYYY');
        const combined = moment(now + last.to, 'MM-DD-YYYY HH:mm');
        const from = moment(combined).add(1, 'hour').format('HH:mm');
        const to = moment(combined).add(2, 'hour').format('HH:mm');
        const next = data.map((v, i) => (i === day ? [...v, { from, to }] : v));
        save(next);
    };
    const remove = (day, interval) => {
        const next = data.map((v, i) => i === day ? v.filter((s) => s !== interval) : v);
        save(next);
    };
    const update = (day, interval, patch) => {
        const next = data.map((v, i) => i === day
            ? v.map((s) => {
                const combined = Object.assign(Object.assign({}, interval), patch);
                if (combined.from > combined.to && combined.to !== '00:00') {
                    const tmp = combined.to;
                    combined.to = combined.from;
                    combined.from = tmp;
                }
                return s === interval ? combined : s;
            })
            : v);
        save(next);
    };
    const toggle = (day) => {
        const current = data[day];
        if (current.length)
            save(data.map((v, i) => (i === day ? [] : v)));
        else
            save(data.map((v, i) => (i === day ? [{ from: '09:00', to: '21:00' }] : v)));
    };
    return (React.createElement(AvailabilityEditorContext.Provider, { value: {
            data,
            add,
            remove,
            update,
            toggle,
            onFrom,
            onTo,
            PickerWrapper
        } }, children));
};
//# sourceMappingURL=AvailabilityEditorContextProvider.js.map